const theme = {
  COLOR_BLACK: '#000',
  COLOR_BLACK_8: 'rgba(0, 0, 0, 0.08)',
  COLOR_BLACK_14: 'rgba(0, 0, 0, 0.14)',
  COLOR_BLACK_20: 'rgba(0, 0, 0, 0.2)',
  COLOR_BLACK_40: 'rgba(0, 0, 0, 0.4)',
  COLOR_BLACK_50: 'rgba(0, 0, 0, 0.5)',
  COLOR_BLACK_55: 'rgba(0, 0, 0, 0.55)',
  COLOR_BLACK_80: 'rgba(0, 0, 0, 0.8)',
  COLOR_BUNKER: '#1d1e1f',
  COLOR_CORN_SILK: '#fff9dc',
  COLOR_DARK_GRAY: '#adadad',
  COLOR_ECLIPSE: '#3a3a3a',
  COLOR_EMPRESS: '#747474',
  COLOR_GAINSBORO: '#ddd',
  COLOR_MORTAR: '#5a5a5a',
  COLOR_NARVIK: '#e4e1d6',
  COLOR_NERO: '#222',
  COLOR_NERO_2: '#1b1b1b',
  COLOR_NERO_3: '#1f1f1f',
  COLOR_NERO_4: '#232323',
  COLOR_NERO_5: '#252525',
  COLOR_NERO_6: '#242424',
  COLOR_NERO_7: '#282828',
  COLOR_NIGHT_RIDER: '#333',
  COLOR_SUVA_GREY: '#898989',
  COLOR_SUVA_GREY_2: '#848180',
  COLOR_VERY_LIGHT_GREY: '#cacaca',
  COLOR_WAN_WHITE: '#e5e2df',
  COLOR_WHITE: '#fff',
  COLOR_WHITE_78: 'rgba(255, 255, 255, 0.78)',
  COLOR_WHITE_90: 'rgba(255, 255, 255, 0.9)',
  COLOR_WHITE_SMOKE: '#eee',
  COLOR_WILD_SAND: '#f5f4f2',
  COLOR_WINTER_HAZEL: '#d2be87',

  FONT_FACE_MINION: 'minion-pro-caption, sans-serif',
  FONT_FACE_THEINHARDT: 'Theinhardt',

  FONT_SIZE_10: 10 / 16,
  FONT_SIZE_11: 11 / 16,
  FONT_SIZE_12: 12 / 16,
  FONT_SIZE_13: 13 / 16,
  FONT_SIZE_14: 14 / 16,
  FONT_SIZE_15: 15 / 16,
  FONT_SIZE_16: 1,
  FONT_SIZE_17: 17 / 16,
  FONT_SIZE_18: 18 / 16,
  FONT_SIZE_19: 19 / 16,
  FONT_SIZE_20: 20 / 16,
  FONT_SIZE_22: 22 / 16,
  FONT_SIZE_21: 21 / 16,
  FONT_SIZE_25: 25 / 16,
  FONT_SIZE_26: 26 / 16,
  FONT_SIZE_29: 29 / 16,
  FONT_SIZE_30: 30 / 16,
  FONT_SIZE_32: 32 / 16,
  FONT_SIZE_33: 33 / 16,
  FONT_SIZE_34: 34 / 16,
  FONT_SIZE_35: 35 / 16,
  FONT_SIZE_36: 36 / 16,
  FONT_SIZE_39: 39 / 16,
  FONT_SIZE_40: 40 / 16,
  FONT_SIZE_42: 42 / 16,
  FONT_SIZE_48: 48 / 16,
  FONT_SIZE_50: 50 / 16,
  FONT_SIZE_52: 52 / 16,
  FONT_SIZE_57: 57 / 16,
  FONT_SIZE_58: 58 / 16,

  FONT_WEIGHT_LIGHT: 300,
  FONT_WEIGHT_NORMAL: 400,
  FONT_WEIGHT_MEDIUM: 500,
  FONT_WEIGHT_BOLD: 700,

  // material-ui
  mui: {
    palette: {
      background: {
        default: '#fff',
      },
    },
  },
};

export type ThemeType = typeof theme;

export default theme;
